import ky from "ky";

const API_URL = process.env.REACT_APP_API_URL;
const PESAPAL_KEY = process.env.REACT_APP_PESAPAL_KEY;

// Create a ky instance with default options
const api = ky.create({
  headers: {
    "Content-Type": "application/json",
    apikey: PESAPAL_KEY,
  },
  timeout: 30000,
  retry: 1,
});

/**
 * Initiates a Pesapal transaction
 * @param {Object} paymentData - Payment data
 * @returns {Promise<Object>} - Response with redirectUrl
 */
export const initiateTransaction = async (paymentData) => {
  try {
    const response = await api
      .post(`${API_URL}/api/pesapal/transaction`, {
        json: {
          ref: paymentData.invoiceId,
          purpose: "Payment for services",
          description: "iHub payment",
          amount: paymentData.amount,
          paymentMethod: "Mpesa",
          currency: "KES",
          userEmail: paymentData.email_address,
          userPhoneNumber: paymentData.phone_number,
          userAddress: "",
          userFirstName: paymentData.first_name,
          userLastName: paymentData.last_name,
        },
      })
      .json();

    return response;
  } catch (error) {
    console.error("Error initiating transaction:", error);
    throw error;
  }
};

/**
 * Verifies a Pesapal transaction status
 * @param {string} invoiceId - Invoice ID to verify
 * @returns {Promise<Object>} - Response with transaction status
 */
export const verifyTransaction = async (invoiceId) => {
  try {
    const response = await api
      .get(`${API_URL}/api/pesapal/transaction/verify/${invoiceId}`)
      .json();
    return response;
  } catch (error) {
    console.error("Error verifying transaction:", error);
    throw error;
  }
};

export const getTransaction = async (invoiceId) => {
  try {
    const response = await api
      .get(`${API_URL}/api/pesapal/transaction/${invoiceId}`)
      .json();
    return response;
  } catch (error) {
    console.error("Error verifying transaction:", error);
    throw error;
  }
};

/**
 * Updates invoice status after successful payment
 * @param {string} invoiceId - Invoice ID to update
 * @returns {Promise<Object>} - Response
 */
export const updateInvoice = async (invoiceId) => {
  try {
    const response = await api
      .put(`${API_URL}/api/update/invoice`, {
        json: { invoiceId },
      })
      .json();
    return response;
  } catch (error) {
    console.error("Error updating invoice:", error);
    throw error;
  }
};
